import { render } from "./RetouchAnswer.vue?vue&type=template&id=36cf3108&scoped=true"
import script from "./RetouchAnswer.vue?vue&type=script&lang=js"
export * from "./RetouchAnswer.vue?vue&type=script&lang=js"

import "./RetouchAnswer.vue?vue&type=style&index=0&id=36cf3108&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cf3108"]])

export default __exports__